/**
 * Typed URL constructors for all internal app routes.
 * Use these instead of hand-rolling path strings so jump-nav and deep links
 * stay in sync with the route tree.
 */
export const appUrls = {
  task: (taskId: string) => `/dashboard/task/${taskId}`,
  taskReport: (taskId: string) => `/dashboard/task/${taskId}/report`,
  inspection: (inspectionId: string) => `/dashboard/inspection/${inspectionId}`,
  propertyMonitoring: (propertyId: string) => `/dashboard/land-monitoring/${propertyId}`,
  propertyReport: (propertyId: string, reportId: string) =>
    `/dashboard/land-monitoring/${propertyId}/${reportId}`,
} as const;
